export const getInitialsFromName = (name: string): string => {
    const nameParts = name.split(' ');

    const firstInitial = nameParts?.[0]?.[0] ?? '';
    const lastInitial = nameParts?.[nameParts.length - 1]?.[0] ?? '';

    let initials = '';

    if (firstInitial.length > 0) {
        initials += firstInitial;
    }

    if (nameParts.length > 1 && lastInitial.length > 0) {
        initials += lastInitial;
    }

    return initials.toUpperCase();
};
